import { Button, Table } from '@insight-health-ai/roseate/components';

import { useMagicFlowContext } from '../MagicFlowContext';

export const RecipesTab = () => {
  const {
    openCreateRecipe,
    recipeTableData,
    recipeColumns,
    isLoadingRecipes,
    isFetchingRecipes,
  } = useMagicFlowContext();

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Button appearance="primary" onClick={openCreateRecipe}>
          Create Recipe
        </Button>
      </div>
      <div className="rounded-xl shadow-xl bg-white">
        <Table
          data={recipeTableData}
          columns={recipeColumns}
          rowKey="key"
          loading={isLoadingRecipes || isFetchingRecipes}
          pagination={{
            defaultPageSize: 10,
            showSizeChanger: true,
            pageSizeOptions: ['10', '20', '50'],
          }}
          emptyText="No recipes"
        />
      </div>
    </div>
  );
};
